/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const CreateDropdown = styled(Button)`
  background-color: ${token('color.background.information.bold', colors.B400)};
  margin-left: ${gridSize() * 1.5}px;

  span > span {
    margin-right: -3px;
  }

  &:hover,
  &:focus,
  &[aria-expanded='true'] {
    background-color: ${token(
      'color.background.information.bold.hovered',
      'rgba(0, 82, 204, 0.9)'
    )};
    span {
      color: ${token('color.text.inverse', colors.N0)};
    }
  }
`;

export const CreateButton = styled(Button)`
  &:hover,
  &:focus,
  &[aria-expanded='true'] {
    background-color: ${token(
      'color.background.information.bold.hovered',
      'rgba(0, 82, 204, 0.9)'
    )};
    span {
      color: ${token('color.text.inverse', colors.N0)};
    }
  }
`;
